import { BaseHandle } from './baseHandle'
import { BaseMarker } from './baseMarker'

export abstract class BaseMarkerHandles<
  MarkerType extends BaseMarker<any, any, any, any>,
  HandleType extends BaseHandle
> {
  protected marker: MarkerType

  constructor(marker: MarkerType) {
    this.marker = marker
  }

  abstract populateHandlePositions(): void

  abstract populate(): void

  /**
   * Compares mouse position returned from p5 to the related marker handle positions
   * and returns the handle instance of the moused over handle, if any.
   */
  getMousedOverHandle(): HandleType | undefined {
    let mousedOverHandle = undefined
    this.marker.state.handles.some((handle: HandleType) => {
      if (handle.isMousedOver()) {
        mousedOverHandle = handle
        return true
      }
      return false
    })
    return mousedOverHandle
  }
}
